import SearchFormController from "./search_form_controller"

export default class extends SearchFormController {
  static targets = ["nameField", "sortField"]

  connect() {
    super.connect()
    this.entityTypeValue = 'end_customer'
  }
}
